export enum PreferredLanguage {
  Bokmal = 'nb',
  Nynorsk = 'nn',
}
